export default [
    {
        path: 'supervisor',
        component: () => import(
            '@/views/transporte-paciente/supervisor/Index'
        ),
        redirect: 'supervisor/list',
        children: [
            {
                name: 'transporte-paciente-supervisor-list',
                path: 'list',
                component: () => import(
                    '@/views/transporte-paciente/supervisor/List'
                ),
            },
            {
                name: 'transporte-paciente-supervisor-create',
                path: 'create',
                component: () => import(
                    '@/views/transporte-paciente/supervisor/Form'
                ),
            },
            {
                name: 'transporte-paciente-supervisor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(
                    '@/views/transporte-paciente/supervisor/Form'
                ),
            },
        ],
    },
]